module.exports = __webpack_public_path__ + "static/img/公司1.e4c91a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/image/公司1.jpg
// module id = ZShY
// module chunks = 1